var _metadata, _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPosition(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg851",
    viewBox: "0 0 13 13",
    height: 13,
    width: 13,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata857"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs855"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#940000",
    "data-name": "Tracciato 4753",
    id: "Tracciato_4753"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#588157",
      fillOpacity: 1
    },
    id: "path846",
    stroke: "none",
    d: "M 6.5 12.5 C 3.191590070724487 12.5 0.5 9.808409690856934 0.5 6.5 C 0.5 3.191590070724487 3.191590070724487 0.5 6.5 0.5 C 9.808409690856934 0.5 12.5 3.191590070724487 12.5 6.5 C 12.5 9.808409690856934 9.808409690856934 12.5 6.5 12.5 Z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path848",
    fill: "#fff",
    stroke: "none",
    d: "M 6.5 1 C 3.467289924621582 1 1 3.467289924621582 1 6.5 C 1 9.532710075378418 3.467289924621582 12 6.5 12 C 9.532710075378418 12 12 9.532710075378418 12 6.5 C 12 3.467289924621582 9.532710075378418 1 6.5 1 M 6.5 0 C 10.0898494720459 0 13 2.910149574279785 13 6.5 C 13 10.0898494720459 10.0898494720459 13 6.5 13 C 2.910149574279785 13 0 10.0898494720459 0 6.5 C 0 2.910149574279785 2.910149574279785 0 6.5 0 Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPosition);
export default __webpack_public_path__ + "static/media/position.d26ad08c7dc63fe0d77af8292ff3cc80.svg";
export { ForwardRef as ReactComponent };